import React from 'react';
import styled, { keyframes } from 'styled-components';

interface LoadingProps {
  position?: {
    type: string;
    left?: string;
    top?: string;
  };
}

// define the circular rotation animation
const l27 = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoadingWrapper = styled.div<LoadingProps>`
  display: flex;
  ${({ position }) =>
    position
      ? `
    position: ${position.type};
    top: ${position.top};
    left: ${position.left};
  `
      : ''}
  justify-content: center;
  align-items: center;
  height: -webkit-fill-available;
  /* --- Loader CSS --- */

  .lds-ring,
  .lds-ring div {
    box-sizing: border-box;
  }

  .lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }

  .lds-ring div {
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    animation: lds-ring 1.2s linear infinite;

    /* ✅ Gradient spinning border */
    background: conic-gradient(#ffc951, #c94daa);
    mask: radial-gradient(farthest-side, transparent calc(100% - 8px), black 0);
  }

  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;



const LoadingDots: React.FC<LoadingProps> = ({ position }) => {
  return <LoadingWrapper position={position}>
    <div className="lds-ring">
      <div></div><div></div><div></div><div></div>
    </div>
  </LoadingWrapper>;
};

export default LoadingDots;
